import { Link, router } from "@inertiajs/react"

import { Select } from "@/components/ui/select"

export type BidSubNavKey = "workspace" | "matrix" | "sheet"

/** The bid area's page-level tabs (Workspace | Plan matrix | Bid sheet) —
 *  link tabs, since each is its own route with its own props payload
 *  (ProfileSubNav pattern), with the documented mobile Select collapse. */
export function BidSubNav({
  active,
  urls,
}: {
  active: BidSubNavKey
  urls: { workspace: string; matrix: string; sheet: string }
}) {
  const tabs: [BidSubNavKey, string][] = [
    ["workspace", "Workspace"],
    ["matrix", "Plan matrix"],
    ["sheet", "Bid sheet"],
  ]

  return (
    <nav aria-label="Bid pages" className="mt-6" data-testid="bid-subnav">
      <div className="hidden gap-6 border-b border-hairline text-sm md:flex">
        {tabs.map(([key, label]) => (
          <Link
            key={key}
            href={urls[key]}
            className={`-mb-px border-b-2 pb-2.5 font-medium ${
              active === key
                ? "border-accent text-ink-display"
                : "border-transparent text-ink-muted hover:text-ink-body"
            }`}
            data-testid={`bid-subnav-${key}`}
          >
            {label}
          </Link>
        ))}
      </div>
      {/* Wrap the responsive class around Select — its className lands on
          the inner <select>, which would leave the wrapper's chevron
          floating on desktop. */}
      <div className="md:hidden">
        <Select
          aria-label="Bid page"
          value={active}
          onChange={(e) => router.visit(urls[e.target.value as BidSubNavKey])}
        >
          {tabs.map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </Select>
      </div>
    </nav>
  )
}
